<template>
  <div class="slide" id="donate" v-show="isVisibleSlide('donate')">
    <div class="container">
      <h2>Before you go:</h2>
      <p>Other countries are making assisted dying legal, and 82% of people support changing the law in Britain. We can win this campaign and get the law changed - but it will take tens of thousands of us signing petitions, contacting MPs and chipping in to fund the campaign to do it.</p>
      <p>{{ $store.state.user.firstname }} - donate now and help win a historic victory for the right to a peaceful death:</p>
      <a
        href="https://action.dignityindying.org.uk/page/40475/donate/1?default_amt=10&utm_source=en-rec"
        target="_blank"
        @click.stop="donate"
        class="button pink"
        style="margin-top:10px;display:inline-block;"
      >Donate</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Donate",
  props: ["gotoSlide", "isVisibleSlide", "analytics"],
  methods: {
    donate() {
      this.analytics("donate", "clicked");
      // eslint-disable-next-line
      fbq("trackCustom", "DonateClicked");
      window.open(
        "https://action.dignityindying.org.uk/page/40475/donate/1?default_amt=10&utm_source=en-rec",
        "_blank"
      );
    }
  }
};
</script>

